<pop-settings-box [labelKey]="label">
  <div middle>

    <input [disabled]="currency.isFunctional"
           class="settings-field rate"
           #currencyInput
           (change)="updateRate(currency, currencyInput.value)"
           [value]="currency.rate"
           type="text" />

    <select *ngIf="!currency.isFunctional"
            [ngModel]="currency.operation"
            class="settings-field operation"
            #operation
            (ngModelChange)="updateOperation(currency, operation.value)">
      <option *ngFor="let operationValue of currencyOperationValues"
              [value]="operationValue"
              [translate]="'CURRENCY_OPERATION.'+operationValue.toUpperCase()"></option>
    </select>
  </div>

  <div aside
       class="description">
    <div class="calculation"
         *ngIf="!currency.isFunctional"
         [matTooltip]="tooltip"
         matTooltipClass="pop-tooltip">
      {{ calculation }}
    </div>

  </div>

</pop-settings-box>
